import React from "react";
import CloseImg from "../../../assets/img/cancel.svg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Modal = ({ modalData, setGetModal }) => {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true,
  };

  return (
    <div className="modal_portfolio">
      <div className="modal__outside" onClick={() => setGetModal(false)}></div>
      <div className="modal__content">
        <div data-aos="fade">
          <h2 className="heading mb-2">{modalData.type}</h2>
          <div className="modal__details">
            {modalData.modalDetails.map((details, i) => {
              return (
                <div key={i} className="row open-sans-font">
                  <div className="d-flex justify-content-center align-items-center col-12 col-sm-6 mb-2">
                    <i className="fa fa-file-text-o pr-2"></i>
                    Project:{" "}
                    <span className="ft-wt-600 uppercase">
                      {details.project}
                    </span>
                  </div>
                  {/* {details.client && (
                    <div className="col-12 col-sm-6 mb-2">
                      <i className="fa fa-user-o pr-2"></i>
                      Client :{" "}
                      <span className="ft-wt-600 uppercase">
                        {details.client}
                      </span>
                    </div>
                  )} */}
                  <div className="d-flex justify-content-center align-items-center col-12 col-sm-6 mb-2">
                    <i className="fa fa-external-link pr-2"></i>
                    Preview:{" "}
                    <a
                      className="preview-link"
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      href={details.link}
                    >
                      {details.preview}
                    </a>
                  </div>
                  {/* <div className="col-12 col-sm-6 mb-2">
                    <i className="fa fa-code pr-2"></i>
                    Language :{" "}
                    <span className="ft-wt-600 uppercase">
                      {details.language}
                    </span>
                  </div> */}
                  <div className="d-flex justify-content-center align-items-center mt-2 flex-column col-12 mb-2">
                    <span>
                      <i className="fa fa-code pr-2"></i>
                      Tech Stack :{" "}
                    </span>
                    <span className="ft-wt-600 uppercase mt-2">
                      <div className="d-flex flex-wrap justify-content-center">
                        {details?.techStack.map((val) => (
                          <img
                            className="bg-white skillsImgBg p-1"
                            style={{
                              borderRadius: "500px",
                              width: "2rem",
                              height: "2rem",
                              objectFit: "contain",
                              marginRight: ".5rem",
                              marginBottom: ".5rem",
                            }}
                            src={val.icon}
                            alt={val.title}
                          />
                        ))}
                      </div>
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
          <figure className="modal__img shadow">
            <Slider {...settings}>
              {modalData.images.map((image) => (
                <div>
                  <img src={image} alt="portfolio project demo" />
                </div>
              ))}
            </Slider>
          </figure>

          <button className="close-modal" onClick={() => setGetModal(false)}>
            <img src={CloseImg} alt="portfolio project demo" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
